import React from 'react';

import { Flex } from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

import { StepLayout } from '../Steps/StepLayout';
import { ConnectCampaignDetailsForm } from './ConnectCampaignDetailsForm';

export const ConnectCampaignDetailsStep = () => {
  return (
    <StepLayout.Container>
      <StepLayout.Header
        title={t('campaignManager.campaignDetails.header.title')}
      />
      <StepLayout.Content>
        <Flex lss={{ flexDirection: 'column', flexBasis: '100%' }}>
          <ConnectCampaignDetailsForm />
        </Flex>
      </StepLayout.Content>
    </StepLayout.Container>
  );
};
